module.exports = __webpack_public_path__ + "static/media/ic_arrow_slider_left.e202f585.svg";